import { Avatar, Box, CardHeader, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

// Building blocks for compact summary cards (wallet page, reports...).

export const formatAmount = (value) =>
  value == null || value === "" ? "-" : Number(value).toLocaleString();

// CardContent padding for these cards (MUI adds extra bottom padding).
export const infoContentSx = { p: 1.5, "&:last-child": { pb: 1.5 } };

// Slim card header: tinted icon, title and an optional action.
export const InfoCardHeader = ({ icon, tone, title, action }) => (
  <CardHeader
    avatar={
      <Avatar
        variant="rounded"
        sx={{
          width: 30,
          height: 30,
          borderRadius: "9px",
          fontSize: 17,
          color: tone,
          bgcolor: alpha(tone, 0.12),
        }}
      >
        {icon}
      </Avatar>
    }
    title={title}
    titleTypographyProps={{ noWrap: true }}
    action={action}
    sx={{
      py: 1,
      px: 1.5,
      "& .MuiCardHeader-avatar": { mr: 1.25 },
      "& .MuiCardHeader-content": { minWidth: 0 },
      "& .MuiCardHeader-title": { fontSize: 14.5 },
      "& .MuiCardHeader-action": { alignSelf: "center", m: 0 },
    }}
  />
);

// A label with its value underneath.
export const InfoField = ({ label, children }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography
      component="div"
      fontSize={14}
      fontWeight={600}
      color="#101828"
      noWrap
    >
      {children || "-"}
    </Typography>
  </Box>
);

// A tinted amount tile (balance, debt...). `action` sits next to the label.
export const StatTile = ({ label, value, tone, action }) => (
  <Box
    sx={{
      flex: "1 1 96px",
      minWidth: 0,
      px: 1.25,
      py: 0.75,
      borderRadius: "10px",
      bgcolor: alpha(tone, 0.08),
    }}
  >
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ minHeight: 20 }}
    >
      <Typography variant="caption" color="text.secondary" noWrap>
        {label}
      </Typography>
      {action}
    </Stack>
    <Typography fontSize={15} fontWeight={800} color={tone} noWrap>
      {formatAmount(value)}{" "}
      <Typography component="span" fontSize={11} fontWeight={600}>
        د.ع
      </Typography>
    </Typography>
  </Box>
);

// Tinted action button (outlined, in its own colour) that sizes to its label
// and stretches to fill a wrapping row.
export const actionButtonSx = (tone) => ({
  flex: "1 1 auto",
  justifyContent: "flex-start",
  py: 0.4,
  fontSize: 13,
  whiteSpace: "nowrap",
  color: tone,
  borderColor: alpha(tone, 0.3),
  bgcolor: alpha(tone, 0.06),
  "&:hover": { borderColor: tone, bgcolor: alpha(tone, 0.14), color: tone },
});
